import Highlight from 'react-highlight';
import 'highlight.js/styles/stackoverflow-light.css';

const CodeRenderer = (text: string) => {
  return <Highlight>{text}</Highlight>;
};

export default CodeRenderer;
